// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3BRhg","colBig":"styles_colBig__2Skbl","colSmall":"styles_colSmall__OTl7R"};